import { render, staticRenderFns } from "./MantenimientosList.vue?vue&type=template&id=35d33289&"
import script from "./MantenimientosList.vue?vue&type=script&lang=js&"
export * from "./MantenimientosList.vue?vue&type=script&lang=js&"
import style0 from "./MantenimientosList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports